import React from "react";
import NavBar from "./components/nav/NavBar";
import Projects from "./components/projects/Projects";

function App() {
  return (
    <>
      <NavBar />
      <Projects />
    </>
  );
}

export default App;
